export default __webpack_public_path__ + "static/media/wa-0054-1.4c650459.jpg";